function getHeaderPosition(): DOMRect | null {
  const header = document.querySelector('.header') as HTMLDivElement
  const headerOrder = document.querySelector('.header-order') as HTMLDivElement
  if(header) return header.getBoundingClientRect()
  if(headerOrder) return headerOrder.getBoundingClientRect()
  return null

}

export default getHeaderPosition
